import { render, staticRenderFns } from "./DialogYearFrame.vue?vue&type=template&id=1f9879c0&scoped=true"
import script from "./DialogYearFrame.vue?vue&type=script&lang=js"
export * from "./DialogYearFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9879c0",
  null
  
)

export default component.exports